// Data Pipeline & MLOps - Optimized Module Exports
import { AIModule } from '@/data/ai/types';

export { DATA_PIPELINE_FUNDAMENTALS_MODULE } from './fundamentals';
export { DATA_PIPELINE_ORCHESTRATION_MODULE } from './orchestration';
export { DATA_PIPELINE_MONITORING_MODULE } from './monitoring';
export { DATA_PIPELINE_DEPLOYMENT_MODULE } from './deployment';

// Combined modules array for course definition
import { DATA_PIPELINE_FUNDAMENTALS_MODULE } from './fundamentals';
import { DATA_PIPELINE_ORCHESTRATION_MODULE } from './orchestration';
import { DATA_PIPELINE_MONITORING_MODULE } from './monitoring';
import { DATA_PIPELINE_DEPLOYMENT_MODULE } from './deployment';

export const DATA_PIPELINE_MODULES: AIModule[] = [
  DATA_PIPELINE_FUNDAMENTALS_MODULE,
  DATA_PIPELINE_ORCHESTRATION_MODULE,
  DATA_PIPELINE_MONITORING_MODULE,
  DATA_PIPELINE_DEPLOYMENT_MODULE
];
